<template>
  <footer class="app-layout-footer" :class="{ fixed }">
    <slot />
  </footer>
</template>

<script>
export default {
  name: 'AppLayoutFooter',

  emits: ['resize'],

  data() {
    return {
      resizeObserver: undefined,
    }
  },

  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    if (this.fixed) this.observeResize()
  },

  beforeUnmount() {
    this.unobserveResize()
  },

  methods: {
    observeResize() {
      const element = this.$el

      this.unobserveResize()

      if (!element) return

      const resizeObserver = new ResizeObserver(() =>
        this.$emit('resize', { height: element.offsetHeight }),
      )

      resizeObserver.observe(element)

      this.resizeObserver = resizeObserver
    },

    unobserveResize() {
      const { resizeObserver } = this

      if (resizeObserver) resizeObserver.disconnect()
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

$borderRadius: 25px;

.app-layout-footer {
  width: 100%;
  z-index: 4;
  position: sticky;
  bottom: 0;

  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
  }
}
</style>
